import { Component, OnInit } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ListaService } from '../../../_services/lista.service';
import { Message, SelectItem } from 'primeng/api';
import { TipoVigencia } from '../../../_enums/enum';
import { NavService } from '../../../_services/_nav.service';
import { forkJoin, Observable, of } from 'rxjs';
import { ListaItem } from '../../../_models/lista-item';
import { AdministradorDocumento } from '../../../_models/administrador-documento';
import { FormChanges } from '../../../_models/formChanges';
import { AdministradorDocumentoService } from '../../../_services/administrador-documento.service';

@Component({
  moduleId: module.id,
  templateUrl: './administration-documents-add.component.html',
  selector: 'administration-documents-add-component'
})

export class AdministrationDocumentsAddComponent implements OnInit {
  formulario: FormGroup;

  loading: boolean = false;
  admDocument: any;
  idDocument: string = '';
  guardando: boolean = false;
  listTypeValidity: SelectItem[] = [];
  tiposVigencia: ListaItem[] = [];
  submitted: boolean = false;
  longitudMaximaDuracion: number = 6;
  maxDuracion: number = this.generarNueves(this.longitudMaximaDuracion);
  msg: Message;
  displayDialog: boolean = false;
  listDocuments: AdministradorDocumento[] = [];

  private formChanges: FormChanges = {
    hasChanges: false,
    initialValue: null
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private listaService: ListaService,
    private navService: NavService,
    private administradorDocumentoService: AdministradorDocumentoService
   ) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.inicializarFormulario();
    this.formulario.valueChanges.subscribe(() => {
      this.formChanges.hasChanges = this.hasFormChanges();
    });
    forkJoin([
      this.listaService.getMasterDetails('ListasTiposVigencias'),
      this.administradorDocumentoService.getAll()
    ]).subscribe({
      next: ([tiposVigencia, documents]) => {
        this.tiposVigencia = tiposVigencia;
        this.listTypeValidity = tiposVigencia.map(item => ({
          label: item.nombre,
          value: item.idLista
        }));
        this.listDocuments = documents;
      },
      error: (error) => {
        console.error('Error loading data:', error);
        this.loading = false;
      }
    });
    this.idDocument = this.route.snapshot.params['id'];
    if (this.idDocument) {
      this.administradorDocumentoService.getById(this.idDocument).subscribe({
        next: (data) => {
          this.admDocument = data;
          this.cargarFormulario();
          this.saveInitialFormState();
          this.loading = false;
        },
        error: (error) => {
          console.error('Error loading data:', error);
          this.loading = false;
        }
      });
    } else {
      this.loading = false;
  }
  }

  inicializarFormulario(): void {
    this.formulario = this.fb.group({
      codigo: ['', Validators.required, this.validarCodigoUnico()],
      nombre: ['', Validators.required],
      idTipoVigencia: ['', Validators.required],
      duracionVigencia: [''],
      descripcion: ['', Validators.required],
      indicadorTercero: [false],
      indicadorSolicitarCliente: [false],
      indicadorHabilitado: [false],
      orden: [null],
    });
  }


  cargarFormulario(): void {
    if (this.admDocument) {
      this.formulario.patchValue({
        codigo: this.admDocument.codigo,
        nombre: this.admDocument.nombre,
        idTipoVigencia: this.admDocument.idTipoVigencia,
        duracionVigencia: this.admDocument.duracionVigencia,
        descripcion: this.admDocument.descripcion,
        indicadorTercero: this.admDocument.indicadorTercero || false,
        indicadorSolicitarCliente: this.admDocument.indicadorSolicitarCliente || false,
        indicadorHabilitado: this.admDocument.indicadorHabilitado,
        orden: this.admDocument.orden,
      });
    }
  }

  get f() {
    return this.formulario.controls;
  }

  private saveInitialFormState(): void {
    this.formChanges.initialValue = JSON.stringify(this.formulario.value);
    this.formChanges.hasChanges = false;
  }

  private hasFormChanges(): boolean {
    if (!this.formChanges.initialValue) return false;
    return this.formChanges.initialValue !== JSON.stringify(this.formulario.value);
  }

  validarCodigoUnico(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any } | null> => {
      if (!control.value || !this.listDocuments) {
        return of(null);
      }

      const codigo = control.value.trim();
      const existeCodigo = this.listDocuments.some(doc =>
        doc.codigo?.toUpperCase() === codigo.toUpperCase() &&
        (!this.idDocument || doc.idDocumentoTercero !== this.idDocument)
      );

      return of(existeCodigo ? { codigoDuplicado: true } : null);
    };
  }

  shouldHideDuration(): boolean {
    const selectedId = this.f.idTipoVigencia.value;
    const selectedType = this.tiposVigencia.find(t => t.idLista === selectedId);
    return selectedType && (selectedType.codigo === TipoVigencia.TEMPO || selectedType.codigo === TipoVigencia.VERIFI);
  }

  convertirAMayusculas(event: Event) {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    input.value = input.value.toUpperCase();
    input.setSelectionRange(start, end);
    this.f.codigo.setValue(input.value, { emitEvent: false });
  }

  limitToThreeDigits(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    if (allowedKeys.includes(event.key)) return;
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }
    if (value.length === 0 && event.key === '0') {
      event.preventDefault();
      return;
    }
    if (value.length >= this.longitudMaximaDuracion) {
      event.preventDefault();
      return;
    }
  }

soloAlfanumerico(event: KeyboardEvent): void {
  const pattern = /^[a-zA-Z0-9]$/;
  if (!pattern.test(event.key)) {
    event.preventDefault();
  }
}

soloAlfanumericoConEspacios(event: KeyboardEvent): void {
  const pattern = /^[a-zA-Z0-9 ]$/;
  if (!pattern.test(event.key)) {
    event.preventDefault();
  }
}

limitarLongitud(event: Event, maxLength: number): void {
  const input = event.target as HTMLInputElement | HTMLTextAreaElement;
  if (input.value.length > maxLength) {
    input.value = input.value.slice(0, maxLength);
  }
}

  generarNueves(n: number): number {
    return +('9'.repeat(n));
  }

  cancelar(): void {
    if (this.formChanges.hasChanges) {
      this.displayDialog = true;
    } else {
      this.goBack();
    }
  }

  goBack(): void {
    this.router.navigate(['/apl/vigencias'], { queryParams: { tab: 2 } });
  }



  onSubmit() {
    this.submitted = true;
    if(this.shouldHideDuration()) {
      this.f.duracionVigencia.setValidators([Validators.required]);
      this.f.duracionVigencia.updateValueAndValidity();
    } else {
      this.f.duracionVigencia.setValidators([]);
      this.f.duracionVigencia.setValue('');
      this.f.duracionVigencia.updateValueAndValidity();
    }

    if (this.formulario.valid) {
      this.guardando = true;
      if (this.idDocument) {
        const data = this.formulario.getRawValue();
        data.idDocumentoTercero = this.idDocument;
        this.administradorDocumentoService.update(data).subscribe(
          () => {
            const typeMessage = 2; // 1 = Add, 2 = Update, 3 Error, 4 Custom
            this.navService.setMesage( typeMessage, this.msg );
            this.goBack();
            this.guardando = false;
          },
          (error) => {
            const typeMessage = 3; // 1 = Add, 2 = Update, 3 Error, 4 Custom
            this.navService.setMesage( typeMessage, this.msg );
            this.guardando = false;
          }
        );
      } else {
        this.administradorDocumentoService.add(this.formulario.value).subscribe(
          () => {
            const typeMessage = 1; // 1 = Add, 2 = Update, 3 Error, 4 Custom
            this.navService.setMesage( typeMessage, this.msg );
            this.goBack();
            this.guardando = false;
          },
          (error) => {
            const typeMessage = 3; // 1 = Add, 2 = Update, 3 Error, 4 Custom
            this.navService.setMesage( typeMessage, this.msg );
            this.guardando = false;
          }
        );
      }
    }
  }

}
